// import React, { useEffect, useRef, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import {
//   Card,
//   Row,
//   CardTitle,
//   CardBody,
//   Button,
//   FormGroup,
//   Label,
//   Input,
// } from 'reactstrap';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';

// const Add_Edit_StudentPayment = () => {
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.authState || {});

//   const isStudent =
//     String(user?.user_profile || '').toLowerCase() === 'student';

//   const [paymentData, setPaymentData] = useState({
//     img_url: '',
//     remarks: '',
//   });

//   const [previewImage, setPreviewImage] = useState('');
//   const [previewType, setPreviewType] = useState('');
//   const [selectedFileName, setSelectedFileName] = useState('');
//   const [errors, setErrors] = useState({
//     img_url: '',
//   });

//   const [branchBankDetail, setBranchBankDetail] = useState(null);
//   const [branchLoading, setBranchLoading] = useState(false);

//   const fileRef = useRef(null);

//   const validateForm = () => {
//     const newErrors = {
//       img_url: '',
//     };

//     let isValid = true;

//     if (!paymentData.img_url && !previewImage && !selectedFileName) {
//       newErrors.img_url = 'Payment proof is mandatory';
//       isValid = false;
//     }

//     setErrors(newErrors);
//     return isValid;
//   };

//   const clearFileState = () => {
//     setPreviewImage('');
//     setPreviewType('');
//     setSelectedFileName('');
//     setPaymentData((prev) => ({
//       ...prev,
//       img_url: '',
//     }));
//     setErrors((prev) => ({
//       ...prev,
//       img_url: 'Payment proof is mandatory',
//     }));

//     if (fileRef.current) {
//       fileRef.current.value = '';
//     }
//   };

//   const onChangeHandle = (e) => {
//     const { name, value, type, files } = e.target;

//     if (type === 'file') {
//       const file = files?.[0];
//       if (!file) return;

//       setSelectedFileName(file.name || '');
//       setPaymentData((prev) => ({
//         ...prev,
//         img_url: file,
//       }));
//       setErrors((prev) => ({
//         ...prev,
//         img_url: '',
//       }));

//       if (file.type === 'application/pdf') {
//         setPreviewImage('');
//         setPreviewType('pdf');
//         return;
//       }

//       if (file.type?.startsWith('image/')) {
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           setPreviewImage(reader.result);
//           setPreviewType('image');
//         };
//         reader.readAsDataURL(file);
//         return;
//       }

//       setPreviewImage('');
//       setPreviewType('');
//       return;
//     }

//     setPaymentData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleOpenFile = () => {
//     if (fileRef.current) {
//       fileRef.current.click();
//     }
//   };

//   const uploadImage = async (file) => {
//     const uploadData = new FormData();
//     uploadData.append('signature', file);

//     const config = {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//         accept: 'application/json',
//       },
//     };

//     const response = await apiService.post(
//       'api/StudentPayment/uploadfile',
//       uploadData,
//       config,
//     );

//     if (response?.status === true) return response.data;
//     throw new Error(response?.message || 'Upload failed');
//   };

//   const uploadIfNeeded = async (obj) => {
//     if (
//       obj.img_url &&
//       typeof obj.img_url === 'object' &&
//       obj.img_url !== null &&
//       'name' in obj.img_url
//     ) {
//       const url = await uploadImage(obj.img_url);
//       obj.img_url = url;
//     }
//   };

//   const fetchBranchBankDetail = async () => {
//     try {
//       setBranchLoading(true);

//       const res = await apiService.get(
//         'api/StudentPayment/my-branch-bank-detail',
//       );

//       if (res?.status === true) {
//         setBranchBankDetail(res.data || null);
//       } else {
//         setBranchBankDetail(null);
//         toast.error(res?.message || 'Branch bank detail not found');
//       }
//     } catch (err) {
//       console.error(err);
//       setBranchBankDetail(null);
//       toast.error(err?.message || 'Failed to load branch bank detail');
//     } finally {
//       setBranchLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBranchBankDetail();
//   }, []);

//   const SaveStudentPayment = async () => {
//     if (!validateForm()) {
//       toast.error('Please upload payment proof');
//       return;
//     }

//     try {
//       const payload = {
//         img_url: paymentData.img_url,
//         remarks: paymentData.remarks || '',
//       };

//       await uploadIfNeeded(payload);

//       const res = await apiService.post(
//         'api/StudentPayment/save-my-payment',
//         payload,
//       );

//       if (res?.status === true) {
//         toast.success(res.message || 'Saved successfully');

//         setPaymentData({
//           img_url: '',
//           remarks: '',
//         });
//         setPreviewImage('');
//         setPreviewType('');
//         setSelectedFileName('');
//         setErrors({
//           img_url: '',
//         });

//         if (fileRef.current) {
//           fileRef.current.value = '';
//         }

//         navigate('/list-student-payment');
//       } else {
//         toast.error(res?.message || 'Failed');
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error(err?.message || 'Something went wrong');
//     }
//   };

//   const qrCodeValue = branchBankDetail?.qr_code || '';

//   const DetailItem = ({ label, value, col = 'col-sm-6' }) => (
//     <div className={`${col} mb-3`}>
//       <div
//         style={{
//           fontSize: '12px',
//           fontWeight: 700,
//           color: '#6c757d',
//           marginBottom: '3px',
//           textTransform: 'uppercase',
//           letterSpacing: '0.3px',
//         }}
//       >
//         {label}
//       </div>
//       <div
//         style={{
//           fontSize: '14px',
//           fontWeight: 500,
//           color: '#212529',
//           lineHeight: '1.4',
//           wordBreak: 'break-word',
//         }}
//       >
//         {value || '-'}
//       </div>
//     </div>
//   );

//   const renderUploadPreview = () => {
//     if (previewType === 'image' && previewImage) {
//       return (
//         <>
//           <div
//             style={{
//               background: '#f8f9fa',
//               padding: '10px 14px',
//               borderBottom: '1px solid #eee',
//               fontWeight: 600,
//               fontSize: '14px',
//             }}
//           >
//             Payment Preview
//           </div>

//           <div style={{ padding: '10px', background: '#fff' }}>
//             <img
//               src={previewImage}
//               alt='Preview'
//               style={{
//                 width: '100%',
//                 maxHeight: '220px',
//                 objectFit: 'contain',
//                 borderRadius: '10px',
//               }}
//             />
//             <div
//               style={{
//                 marginTop: '8px',
//                 fontSize: '13px',
//                 color: '#6c757d',
//                 textAlign: 'center',
//               }}
//             >
//               Click to change file
//             </div>
//           </div>
//         </>
//       );
//     }

//     if (previewType === 'pdf') {
//       return (
//         <>
//           <div
//             style={{
//               background: '#f8f9fa',
//               padding: '10px 14px',
//               borderBottom: '1px solid #eee',
//               fontWeight: 600,
//               fontSize: '14px',
//             }}
//           >
//             Payment Preview
//           </div>

//           <div
//             style={{
//               minHeight: '170px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               flexDirection: 'column',
//               background: '#fff',
//               padding: '20px',
//             }}
//           >
//             <i
//               className='bi bi-file-earmark-pdf'
//               style={{
//                 fontSize: '46px',
//                 marginBottom: '8px',
//                 color: '#dc3545',
//               }}
//             />
//             <div
//               style={{
//                 fontSize: '15px',
//                 fontWeight: 600,
//                 textAlign: 'center',
//                 wordBreak: 'break-word',
//               }}
//             >
//               {selectedFileName || 'PDF selected'}
//             </div>
//             <div
//               style={{
//                 marginTop: '6px',
//                 fontSize: '13px',
//                 color: '#6c757d',
//                 textAlign: 'center',
//               }}
//             >
//               Click to change file
//             </div>
//           </div>
//         </>
//       );
//     }

//     return (
//       <div
//         style={{
//           minHeight: '170px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           flexDirection: 'column',
//           background: '#fafafa',
//           padding: '24px 16px',
//           border: '2px dashed #d5d5d5',
//           borderRadius: '14px',
//           margin: '10px',
//         }}
//       >
//         <i
//           className='bi bi-cloud-upload'
//           style={{
//             fontSize: '36px',
//             marginBottom: '8px',
//             color: '#6c757d',
//           }}
//         />
//         <div style={{ fontSize: '16px', fontWeight: 600 }}>
//           Upload payment file
//         </div>
//         <div
//           style={{
//             fontSize: '13px',
//             color: '#6c757d',
//             marginTop: '4px',
//             textAlign: 'center',
//           }}
//         >
//           Screenshot, receipt, or payment proof
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Card className='card-box pd-20 mb-20'>
//       <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
//         <span>Student Payment Form</span>

//         <div className='d-flex gap-2'>
//           {isStudent && (
//             <Button
//               color='info'
//               onClick={() => navigate('/list-student-payment')}
//             >
//               All Payment
//             </Button>
//           )}

//           <Button color='warning' onClick={() => navigate(-1)}>
//             <i className='bi bi-arrow-left' />
//           </Button>
//         </div>
//       </CardTitle>

//       <CardBody>
//         <Row className='g-3'>
//           <div className='col-lg-6'>
//             <div
//               style={{
//                 border: '1px solid #e9ecef',
//                 borderRadius: '16px',
//                 background: '#fff',
//                 boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div
//                 style={{
//                   background:
//                     'linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%)',
//                   padding: '12px 16px',
//                   borderBottom: '1px solid #eee',
//                   fontWeight: 700,
//                   fontSize: '15px',
//                 }}
//               >
//                 Bank Details
//               </div>

//               <div style={{ padding: '14px 16px 8px' }}>
//                 {branchLoading ? (
//                   <div>Loading branch bank details...</div>
//                 ) : branchBankDetail ? (
//                   <>
//                     <div className='row'>
//                       <DetailItem
//                         label='Branch Name'
//                         value={branchBankDetail.branch_name}
//                       />
//                       <DetailItem
//                         label='Bank Name'
//                         value={branchBankDetail.branch_bank_name}
//                       />
//                       <DetailItem
//                         label='Bank Branch'
//                         value={branchBankDetail.branch_bank_branch}
//                       />
//                       <DetailItem
//                         label='Account Holder'
//                         value={branchBankDetail.branch_bank_holder_name}
//                       />
//                       <DetailItem
//                         label='Account Number'
//                         value={branchBankDetail.branch_bank_acc}
//                       />
//                       <DetailItem
//                         label='IFSC Code'
//                         value={branchBankDetail.branch_bank_ifcs}
//                       />
//                       <DetailItem
//                         label='Swift Code'
//                         value={branchBankDetail.branch_bank_swift_code}
//                       />
//                       <DetailItem
//                         label='Contact'
//                         value={branchBankDetail.branch_contact}
//                       />
//                       <DetailItem
//                         label='Address'
//                         value={branchBankDetail.branch_address}
//                         col='col-sm-12'
//                       />
//                     </div>

//                     <div
//                       style={{
//                         borderTop: '1px solid #eee',
//                         marginTop: '6px',
//                         paddingTop: '14px',
//                       }}
//                     >
//                       <div
//                         style={{
//                           fontSize: '14px',
//                           fontWeight: 700,
//                           marginBottom: '10px',
//                           color: '#212529',
//                         }}
//                       >
//                         QR Code
//                       </div>

//                       <div
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           minHeight: '170px',
//                           background: '#fafafa',
//                           border: '1px solid #eee',
//                           borderRadius: '14px',
//                           padding: '12px',
//                           textAlign: 'center',
//                         }}
//                       >
//                         {qrCodeValue ? (
//                           <div>
//                             <img
//                               src={qrCodeValue}
//                               alt='Branch QR Code'
//                               style={{
//                                 width: '100%',
//                                 maxWidth: '170px',
//                                 maxHeight: '170px',
//                                 objectFit: 'contain',
//                                 borderRadius: '10px',
//                                 background: '#fff',
//                               }}
//                             />
//                             <div
//                               style={{
//                                 marginTop: '8px',
//                                 color: '#6c757d',
//                                 fontSize: '12px',
//                               }}
//                             >
//                               Scan this QR for payment
//                             </div>
//                           </div>
//                         ) : (
//                           <div>
//                             <i
//                               className='bi bi-qr-code'
//                               style={{
//                                 fontSize: '42px',
//                                 color: '#adb5bd',
//                                 marginBottom: '8px',
//                               }}
//                             />
//                             <div style={{ color: '#6c757d', fontSize: '13px' }}>
//                               QR code not available
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </>
//                 ) : (
//                   <div className='text-danger'>
//                     Branch bank details not available for this user.
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className='col-lg-6'>
//             <div
//               style={{
//                 border: '1px solid #e9ecef',
//                 borderRadius: '16px',
//                 background: '#fff',
//                 boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div
//                 style={{
//                   background:
//                     'linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%)',
//                   padding: '12px 16px',
//                   borderBottom: '1px solid #eee',
//                   fontWeight: 700,
//                   fontSize: '15px',
//                 }}
//               >
//                 Upload Payment Proof
//               </div>

//               <div style={{ padding: '14px 16px 16px' }}>
//                 <FormGroup className='mb-3'>
//                   <Label className='fw-bold mb-2 d-block'>
//                     Payment Proof <span className='text-danger'>*</span>
//                   </Label>

//                   <Input
//                     id='img_url'
//                     name='img_url'
//                     type='file'
//                     accept='image/*,.pdf'
//                     innerRef={fileRef}
//                     onChange={onChangeHandle}
//                     className='d-none'
//                     invalid={!!errors.img_url}
//                   />

//                   <div
//                     onClick={handleOpenFile}
//                     style={{
//                       width: '100%',
//                       border: errors.img_url
//                         ? '1px solid #dc3545'
//                         : '1px solid #ddd',
//                       borderRadius: '14px',
//                       background: '#fff',
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//                       overflow: 'hidden',
//                       cursor: 'pointer',
//                     }}
//                   >
//                     {renderUploadPreview()}
//                   </div>

//                   {errors.img_url && (
//                     <div
//                       className='text-danger mt-2'
//                       style={{ fontSize: '0.875rem' }}
//                     >
//                       {errors.img_url}
//                     </div>
//                   )}

//                   <div className='d-flex gap-2 flex-wrap mt-3'>
//                     {!previewImage && !selectedFileName && (
//                       <Button
//                         color='primary'
//                         style={{ minWidth: '140px' }}
//                         onClick={handleOpenFile}
//                       >
//                         Upload File
//                       </Button>
//                     )}

//                     {(previewImage || selectedFileName) && (
//                       <Button
//                         color='secondary'
//                         style={{ minWidth: '140px' }}
//                         onClick={clearFileState}
//                       >
//                         Remove
//                       </Button>
//                     )}
//                   </div>
//                 </FormGroup>

//                 <FormGroup className='mb-0'>
//                   <Label className='fw-bold mb-2'>Remarks</Label>
//                   <Input
//                     type='textarea'
//                     name='remarks'
//                     value={paymentData.remarks || ''}
//                     onChange={onChangeHandle}
//                     rows={4}
//                     placeholder='Write your payment remarks here...'
//                     style={{
//                       borderRadius: '12px',
//                       padding: '12px',
//                       resize: 'none',
//                     }}
//                   />
//                 </FormGroup>

//                 <div className='d-flex justify-content-end mt-3'>
//                   <Button
//                     color='primary'
//                     style={{
//                       minWidth: '140px',
//                       borderRadius: '10px',
//                       fontWeight: 600,
//                     }}
//                     onClick={SaveStudentPayment}
//                   >
//                     Save
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Row>
//       </CardBody>
//     </Card>
//   );
// };

// export default Add_Edit_StudentPayment;
// ////new
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const FILE_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(
  /\/+$/,
  '',
);

const Add_Edit_StudentPayment = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authState || {});

  const isStudent =
    String(user?.user_profile || '').toLowerCase() === 'student';

  const [paymentData, setPaymentData] = useState({
    img_url: '',
    remarks: '',
  });

  const [previewImage, setPreviewImage] = useState('');
  const [previewType, setPreviewType] = useState('');
  const [selectedFileName, setSelectedFileName] = useState('');
  const [errors, setErrors] = useState({
    img_url: '',
  });

  const [branchBankDetail, setBranchBankDetail] = useState(null);
  const [branchLoading, setBranchLoading] = useState(false);
  const [qrLoadError, setQrLoadError] = useState(false);

  const fileRef = useRef(null);

  const validateForm = () => {
    const newErrors = {
      img_url: '',
    };

    let isValid = true;

    if (!paymentData.img_url && !previewImage && !selectedFileName) {
      newErrors.img_url = 'Payment proof is mandatory';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const clearFileState = () => {
    setPreviewImage('');
    setPreviewType('');
    setSelectedFileName('');
    setPaymentData((prev) => ({
      ...prev,
      img_url: '',
    }));
    setErrors((prev) => ({
      ...prev,
      img_url: 'Payment proof is mandatory',
    }));

    if (fileRef.current) {
      fileRef.current.value = '';
    }
  };

  const onChangeHandle = (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      const file = files?.[0];
      if (!file) return;

      setSelectedFileName(file.name || '');
      setPaymentData((prev) => ({
        ...prev,
        img_url: file,
      }));
      setErrors((prev) => ({
        ...prev,
        img_url: '',
      }));

      if (file.type === 'application/pdf') {
        setPreviewImage('');
        setPreviewType('pdf');
        return;
      }

      if (file.type?.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
          setPreviewType('image');
        };
        reader.readAsDataURL(file);
        return;
      }

      setPreviewImage('');
      setPreviewType('');
      return;
    }

    setPaymentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenFile = () => {
    if (fileRef.current) {
      fileRef.current.click();
    }
  };

  const uploadImage = async (file) => {
    const uploadData = new FormData();
    uploadData.append('signature', file);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        accept: 'application/json',
      },
    };

    const response = await apiService.post(
      'api/StudentPayment/uploadfile',
      uploadData,
      config,
    );

    if (response?.status === true) {
      return response?.data || response?.Data || '';
    }

    throw new Error(response?.message || response?.Message || 'Upload failed');
  };

  const uploadIfNeeded = async (obj) => {
    if (
      obj.img_url &&
      typeof obj.img_url === 'object' &&
      obj.img_url !== null &&
      'name' in obj.img_url
    ) {
      const url = await uploadImage(obj.img_url);
      obj.img_url = url;
    }
  };

  const fetchBranchBankDetail = async () => {
    try {
      setBranchLoading(true);
      setQrLoadError(false);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        'api/StudentPayment/my-branch-bank-detail',
        config,
      );

      if (response?.response?.data?.errors) {
        toast.error(response.response.data.errors);
        setBranchBankDetail(null);
        return;
      }

      if (response?.status === true) {
        const payload = response?.data || response?.Data || null;
        console.log('Branch bank detail response:', response);
        console.log('Branch payload:', payload);
        console.log('QR raw value:', payload?.qr_code);

        setBranchBankDetail(payload);
      } else {
        setBranchBankDetail(null);
        toast.error(
          response?.message ||
            response?.Message ||
            'Branch bank detail not found',
        );
      }
    } catch (error) {
      console.error(error);
      setBranchBankDetail(null);
      toast.error('SomeThing went wrong!!');
    } finally {
      setBranchLoading(false);
    }
  };

  useEffect(() => {
    fetchBranchBankDetail();
  }, []);

  const SaveStudentPayment = async () => {
    if (!validateForm()) {
      toast.error('Please upload payment proof');
      return;
    }

    try {
      const payload = {
        img_url: paymentData.img_url,
        remarks: paymentData.remarks || '',
      };

      await uploadIfNeeded(payload);

      const res = await apiService.post(
        'api/StudentPayment/save-my-payment',
        payload,
      );

      if (res?.status === true) {
        toast.success(res?.message || res?.Message || 'Saved successfully');

        setPaymentData({
          img_url: '',
          remarks: '',
        });
        setPreviewImage('');
        setPreviewType('');
        setSelectedFileName('');
        setErrors({
          img_url: '',
        });

        if (fileRef.current) {
          fileRef.current.value = '';
        }

        navigate('/list-student-payment');
      } else {
        toast.error(res?.message || res?.Message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.message || 'Something went wrong');
    }
  };

  const qrCodeSrc = branchBankDetail?.qr_code
    ? `${FILE_BASE_URL}/${String(branchBankDetail.qr_code).replace(/^\/+/, '')}`
    : '';

  const DetailItem = ({ label, value, col = 'col-sm-6' }) => (
    <div className={`${col} mb-3`}>
      <div
        style={{
          fontSize: '12px',
          fontWeight: 700,
          color: '#6c757d',
          marginBottom: '3px',
          textTransform: 'uppercase',
          letterSpacing: '0.3px',
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: '14px',
          fontWeight: 500,
          color: '#212529',
          lineHeight: '1.4',
          wordBreak: 'break-word',
        }}
      >
        {value || '-'}
      </div>
    </div>
  );

  const renderUploadPreview = () => {
    if (previewType === 'image' && previewImage) {
      return (
        <>
          <div
            style={{
              background: '#f8f9fa',
              padding: '10px 14px',
              borderBottom: '1px solid #eee',
              fontWeight: 600,
              fontSize: '14px',
            }}
          >
            Payment Preview
          </div>

          <div style={{ padding: '10px', background: '#fff' }}>
            <img
              src={previewImage}
              alt='Preview'
              style={{
                width: '100%',
                maxHeight: '220px',
                objectFit: 'contain',
                borderRadius: '10px',
              }}
            />
            <div
              style={{
                marginTop: '8px',
                fontSize: '13px',
                color: '#6c757d',
                textAlign: 'center',
              }}
            >
              Click to change file
            </div>
          </div>
        </>
      );
    }

    if (previewType === 'pdf') {
      return (
        <>
          <div
            style={{
              background: '#f8f9fa',
              padding: '10px 14px',
              borderBottom: '1px solid #eee',
              fontWeight: 600,
              fontSize: '14px',
            }}
          >
            Payment Preview
          </div>

          <div
            style={{
              minHeight: '170px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              background: '#fff',
              padding: '20px',
            }}
          >
            <i
              className='bi bi-file-earmark-pdf'
              style={{
                fontSize: '46px',
                marginBottom: '8px',
                color: '#dc3545',
              }}
            />
            <div
              style={{
                fontSize: '15px',
                fontWeight: 600,
                textAlign: 'center',
                wordBreak: 'break-word',
              }}
            >
              {selectedFileName || 'PDF selected'}
            </div>
            <div
              style={{
                marginTop: '6px',
                fontSize: '13px',
                color: '#6c757d',
                textAlign: 'center',
              }}
            >
              Click to change file
            </div>
          </div>
        </>
      );
    }

    return (
      <div
        style={{
          minHeight: '170px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          background: '#fafafa',
          padding: '24px 16px',
          border: '2px dashed #d5d5d5',
          borderRadius: '14px',
          margin: '10px',
        }}
      >
        <i
          className='bi bi-cloud-upload'
          style={{
            fontSize: '36px',
            marginBottom: '8px',
            color: '#6c757d',
          }}
        />
        <div style={{ fontSize: '16px', fontWeight: 600 }}>
          Upload payment file
        </div>
        <div
          style={{
            fontSize: '13px',
            color: '#6c757d',
            marginTop: '4px',
            textAlign: 'center',
          }}
        >
          Screenshot, receipt, or payment proof
        </div>
      </div>
    );
  };

  return (
    <Card className='card-box pd-20 mb-20'>
      <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
        <span>Student Payment Form</span>

        <div className='d-flex gap-2'>
          {isStudent && (
            <Button
              color='info'
              onClick={() => navigate('/list-student-payment')}
            >
              All Payment
            </Button>
          )}

          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </div>
      </CardTitle>

      <CardBody>
        <Row className='g-3'>
          <div className='col-lg-6'>
            <div
              style={{
                border: '1px solid #e9ecef',
                borderRadius: '16px',
                background: '#fff',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                overflow: 'hidden',
                height: '100%',
              }}
            >
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: 700,
                  marginBottom: '10px',
                  color: '#212529',
                }}
              >
                QR Code
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '170px',
                  background: '#fafafa',
                  border: '1px solid #eee',
                  borderRadius: '14px',
                  padding: '12px',
                  textAlign: 'center',
                }}
              >
                {qrCodeSrc && !qrLoadError ? (
                  <div>
                    <img
                      src={qrCodeSrc}
                      alt='Branch QR Code'
                      onError={() => {
                        console.error('QR image load failed:', qrCodeSrc);
                        setQrLoadError(true);
                      }}
                      style={{
                        width: '100%',
                        maxWidth: '170px',
                        maxHeight: '170px',
                        objectFit: 'contain',
                        borderRadius: '10px',
                        background: '#fff',
                      }}
                    />
                    <div
                      style={{
                        marginTop: '8px',
                        color: '#6c757d',
                        fontSize: '12px',
                      }}
                    >
                      Scan this QR for payment
                    </div>
                  </div>
                ) : (
                  <div>
                    <i
                      className='bi bi-qr-code'
                      style={{
                        fontSize: '42px',
                        color: '#adb5bd',
                        marginBottom: '8px',
                      }}
                    />
                    <div style={{ color: '#6c757d', fontSize: '13px' }}>
                      QR code not available
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  background:
                    'linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%)',
                  padding: '12px 16px',
                  borderBottom: '1px solid #eee',
                  fontWeight: 700,
                  fontSize: '15px',
                }}
              >
                Bank Details
              </div>

              <div style={{ padding: '14px 16px 8px' }}>
                {branchLoading ? (
                  <div>Loading branch bank details...</div>
                ) : branchBankDetail ? (
                  <>
                    <div className='row'>
                      <DetailItem
                        label='Branch Name'
                        value={branchBankDetail.branch_name}
                      />
                      <DetailItem
                        label='Bank Name'
                        value={branchBankDetail.branch_bank_name}
                      />
                      <DetailItem
                        label='Bank Branch'
                        value={branchBankDetail.branch_bank_branch}
                      />
                      <DetailItem
                        label='Account Holder'
                        value={branchBankDetail.branch_bank_holder_name}
                      />
                      <DetailItem
                        label='Account Number'
                        value={branchBankDetail.branch_bank_acc}
                      />
                      <DetailItem
                        label='IFSC Code'
                        value={branchBankDetail.branch_bank_ifcs}
                      />
                      <DetailItem
                        label='Swift Code'
                        value={branchBankDetail.branch_bank_swift_code}
                      />
                      <DetailItem
                        label='Contact'
                        value={branchBankDetail.branch_contact}
                      />
                      <DetailItem
                        label='Address'
                        value={branchBankDetail.branch_address}
                        col='col-sm-12'
                      />
                    </div>

                    <div
                      style={{
                        borderTop: '1px solid #eee',
                        marginTop: '6px',
                        paddingTop: '14px',
                      }}
                    ></div>
                  </>
                ) : (
                  <div className='text-danger'>
                    Branch bank details not available for this user.
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className='col-lg-6'>
            <div
              style={{
                border: '1px solid #e9ecef',
                borderRadius: '16px',
                background: '#fff',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                overflow: 'hidden',
                height: '100%',
              }}
            >
              <div
                style={{
                  background:
                    'linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%)',
                  padding: '12px 16px',
                  borderBottom: '1px solid #eee',
                  fontWeight: 700,
                  fontSize: '15px',
                }}
              >
                Upload Payment Proof
              </div>

              <div style={{ padding: '14px 16px 16px' }}>
                <FormGroup className='mb-3'>
                  <Label className='fw-bold mb-2 d-block'>
                    Payment Proof <span className='text-danger'>*</span>
                  </Label>

                  <Input
                    id='img_url'
                    name='img_url'
                    type='file'
                    accept='image/*,.pdf'
                    innerRef={fileRef}
                    onChange={onChangeHandle}
                    className='d-none'
                    invalid={!!errors.img_url}
                  />

                  <div
                    onClick={handleOpenFile}
                    style={{
                      width: '100%',
                      border: errors.img_url
                        ? '1px solid #dc3545'
                        : '1px solid #ddd',
                      borderRadius: '14px',
                      background: '#fff',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      overflow: 'hidden',
                      cursor: 'pointer',
                    }}
                  >
                    {renderUploadPreview()}
                  </div>

                  {errors.img_url && (
                    <div
                      className='text-danger mt-2'
                      style={{ fontSize: '0.875rem' }}
                    >
                      {errors.img_url}
                    </div>
                  )}

                  {(previewImage || selectedFileName) && (
                    <div className='d-flex gap-2 flex-wrap mt-3'>
                      <Button
                        color='secondary'
                        style={{ minWidth: '140px' }}
                        onClick={clearFileState}
                      >
                        Remove
                      </Button>
                    </div>
                  )}
                </FormGroup>

                <FormGroup className='mb-0'>
                  <Label className='fw-bold mb-2'>Remarks</Label>
                  <Input
                    type='textarea'
                    name='remarks'
                    value={paymentData.remarks || ''}
                    onChange={onChangeHandle}
                    rows={4}
                    placeholder='Write your payment remarks here...'
                    style={{
                      borderRadius: '12px',
                      padding: '12px',
                      resize: 'none',
                    }}
                  />
                </FormGroup>

                <div className='d-flex justify-content-end mt-3'>
                  <Button
                    color='primary'
                    style={{
                      minWidth: '140px',
                      borderRadius: '10px',
                      fontWeight: 600,
                    }}
                    onClick={SaveStudentPayment}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Add_Edit_StudentPayment;
